/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrashRouteImport } from './routes/trash'
import { Route as TrafficRouteImport } from './routes/traffic'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SeoRouteImport } from './routes/seo'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ResumeRouteImport } from './routes/resume'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as FediverseRouteImport } from './routes/fediverse'
import { Route as EventsRouteImport } from './routes/events'
import { Route as ContentRouteImport } from './routes/content'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as CacheRouteImport } from './routes/cache'
import { Route as AnalysisRouteImport } from './routes/analysis'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PostsIndexRouteImport } from './routes/posts/index'
import { Route as PortfolioIndexRouteImport } from './routes/portfolio/index'
import { Route as MemoryIndexRouteImport } from './routes/memory/index'
import { Route as PostsNewRouteImport } from './routes/posts/new'
import { Route as PostsSlugRouteImport } from './routes/posts/$slug'
import { Route as PortfolioNewRouteImport } from './routes/portfolio/new'
import { Route as PortfolioIdRouteImport } from './routes/portfolio/$id'
import { Route as MemoryVisitorIdRouteImport } from './routes/memory/$visitorId'

const TrashRoute = TrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => rootRouteImport,
} as any)
const TrafficRoute = TrafficRouteImport.update({
  id: '/traffic',
  path: '/traffic',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SeoRoute = SeoRouteImport.update({
  id: '/seo',
  path: '/seo',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ResumeRoute = ResumeRouteImport.update({
  id: '/resume',
  path: '/resume',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRoute = MessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const FediverseRoute = FediverseRouteImport.update({
  id: '/fediverse',
  path: '/fediverse',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentRoute = ContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const CacheRoute = CacheRouteImport.update({
  id: '/cache',
  path: '/cache',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalysisRoute = AnalysisRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsIndexRoute = PostsIndexRouteImport.update({
  id: '/posts/',
  path: '/posts/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioIndexRoute = PortfolioIndexRouteImport.update({
  id: '/portfolio/',
  path: '/portfolio/',
  getParentRoute: () => rootRouteImport,
} as any)
const MemoryIndexRoute = MemoryIndexRouteImport.update({
  id: '/memory/',
  path: '/memory/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsNewRoute = PostsNewRouteImport.update({
  id: '/posts/new',
  path: '/posts/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsSlugRoute = PostsSlugRouteImport.update({
  id: '/posts/$slug',
  path: '/posts/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioNewRoute = PortfolioNewRouteImport.update({
  id: '/portfolio/new',
  path: '/portfolio/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioIdRoute = PortfolioIdRouteImport.update({
  id: '/portfolio/$id',
  path: '/portfolio/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MemoryVisitorIdRoute = MemoryVisitorIdRouteImport.update({
  id: '/memory/$visitorId',
  path: '/memory/$visitorId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analysis': typeof AnalysisRoute
  '/cache': typeof CacheRoute
  '/chat': typeof ChatRoute
  '/content': typeof ContentRoute
  '/events': typeof EventsRoute
  '/fediverse': typeof FediverseRoute
  '/messages': typeof MessagesRoute
  '/resume': typeof ResumeRoute
  '/search': typeof SearchRoute
  '/seo': typeof SeoRoute
  '/settings': typeof SettingsRoute
  '/traffic': typeof TrafficRoute
  '/trash': typeof TrashRoute
  '/memory/$visitorId': typeof MemoryVisitorIdRoute
  '/portfolio/$id': typeof PortfolioIdRoute
  '/portfolio/new': typeof PortfolioNewRoute
  '/posts/$slug': typeof PostsSlugRoute
  '/posts/new': typeof PostsNewRoute
  '/memory/': typeof MemoryIndexRoute
  '/portfolio/': typeof PortfolioIndexRoute
  '/posts/': typeof PostsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analysis': typeof AnalysisRoute
  '/cache': typeof CacheRoute
  '/chat': typeof ChatRoute
  '/content': typeof ContentRoute
  '/events': typeof EventsRoute
  '/fediverse': typeof FediverseRoute
  '/messages': typeof MessagesRoute
  '/resume': typeof ResumeRoute
  '/search': typeof SearchRoute
  '/seo': typeof SeoRoute
  '/settings': typeof SettingsRoute
  '/traffic': typeof TrafficRoute
  '/trash': typeof TrashRoute
  '/memory/$visitorId': typeof MemoryVisitorIdRoute
  '/portfolio/$id': typeof PortfolioIdRoute
  '/portfolio/new': typeof PortfolioNewRoute
  '/posts/$slug': typeof PostsSlugRoute
  '/posts/new': typeof PostsNewRoute
  '/memory': typeof MemoryIndexRoute
  '/portfolio': typeof PortfolioIndexRoute
  '/posts': typeof PostsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analysis': typeof AnalysisRoute
  '/cache': typeof CacheRoute
  '/chat': typeof ChatRoute
  '/content': typeof ContentRoute
  '/events': typeof EventsRoute
  '/fediverse': typeof FediverseRoute
  '/messages': typeof MessagesRoute
  '/resume': typeof ResumeRoute
  '/search': typeof SearchRoute
  '/seo': typeof SeoRoute
  '/settings': typeof SettingsRoute
  '/traffic': typeof TrafficRoute
  '/trash': typeof TrashRoute
  '/memory/$visitorId': typeof MemoryVisitorIdRoute
  '/portfolio/$id': typeof PortfolioIdRoute
  '/portfolio/new': typeof PortfolioNewRoute
  '/posts/$slug': typeof PostsSlugRoute
  '/posts/new': typeof PostsNewRoute
  '/memory/': typeof MemoryIndexRoute
  '/portfolio/': typeof PortfolioIndexRoute
  '/posts/': typeof PostsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analysis'
    | '/cache'
    | '/chat'
    | '/content'
    | '/events'
    | '/fediverse'
    | '/messages'
    | '/resume'
    | '/search'
    | '/seo'
    | '/settings'
    | '/traffic'
    | '/trash'
    | '/memory/$visitorId'
    | '/portfolio/$id'
    | '/portfolio/new'
    | '/posts/$slug'
    | '/posts/new'
    | '/memory/'
    | '/portfolio/'
    | '/posts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analysis'
    | '/cache'
    | '/chat'
    | '/content'
    | '/events'
    | '/fediverse'
    | '/messages'
    | '/resume'
    | '/search'
    | '/seo'
    | '/settings'
    | '/traffic'
    | '/trash'
    | '/memory/$visitorId'
    | '/portfolio/$id'
    | '/portfolio/new'
    | '/posts/$slug'
    | '/posts/new'
    | '/memory'
    | '/portfolio'
    | '/posts'
  id:
    | '__root__'
    | '/'
    | '/analysis'
    | '/cache'
    | '/chat'
    | '/content'
    | '/events'
    | '/fediverse'
    | '/messages'
    | '/resume'
    | '/search'
    | '/seo'
    | '/settings'
    | '/traffic'
    | '/trash'
    | '/memory/$visitorId'
    | '/portfolio/$id'
    | '/portfolio/new'
    | '/posts/$slug'
    | '/posts/new'
    | '/memory/'
    | '/portfolio/'
    | '/posts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalysisRoute: typeof AnalysisRoute
  CacheRoute: typeof CacheRoute
  ChatRoute: typeof ChatRoute
  ContentRoute: typeof ContentRoute
  EventsRoute: typeof EventsRoute
  FediverseRoute: typeof FediverseRoute
  MessagesRoute: typeof MessagesRoute
  ResumeRoute: typeof ResumeRoute
  SearchRoute: typeof SearchRoute
  SeoRoute: typeof SeoRoute
  SettingsRoute: typeof SettingsRoute
  TrafficRoute: typeof TrafficRoute
  TrashRoute: typeof TrashRoute
  MemoryVisitorIdRoute: typeof MemoryVisitorIdRoute
  PortfolioIdRoute: typeof PortfolioIdRoute
  PortfolioNewRoute: typeof PortfolioNewRoute
  PostsSlugRoute: typeof PostsSlugRoute
  PostsNewRoute: typeof PostsNewRoute
  MemoryIndexRoute: typeof MemoryIndexRoute
  PortfolioIndexRoute: typeof PortfolioIndexRoute
  PostsIndexRoute: typeof PostsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trash': {
      id: '/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof TrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/traffic': {
      id: '/traffic'
      path: '/traffic'
      fullPath: '/traffic'
      preLoaderRoute: typeof TrafficRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seo': {
      id: '/seo'
      path: '/seo'
      fullPath: '/seo'
      preLoaderRoute: typeof SeoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resume': {
      id: '/resume'
      path: '/resume'
      fullPath: '/resume'
      preLoaderRoute: typeof ResumeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fediverse': {
      id: '/fediverse'
      path: '/fediverse'
      fullPath: '/fediverse'
      preLoaderRoute: typeof FediverseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content': {
      id: '/content'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof ContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cache': {
      id: '/cache'
      path: '/cache'
      fullPath: '/cache'
      preLoaderRoute: typeof CacheRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analysis': {
      id: '/analysis'
      path: '/analysis'
      fullPath: '/analysis'
      preLoaderRoute: typeof AnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/': {
      id: '/posts/'
      path: '/posts'
      fullPath: '/posts/'
      preLoaderRoute: typeof PostsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/': {
      id: '/portfolio/'
      path: '/portfolio'
      fullPath: '/portfolio/'
      preLoaderRoute: typeof PortfolioIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memory/': {
      id: '/memory/'
      path: '/memory'
      fullPath: '/memory/'
      preLoaderRoute: typeof MemoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/new': {
      id: '/posts/new'
      path: '/posts/new'
      fullPath: '/posts/new'
      preLoaderRoute: typeof PostsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/$slug': {
      id: '/posts/$slug'
      path: '/posts/$slug'
      fullPath: '/posts/$slug'
      preLoaderRoute: typeof PostsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/new': {
      id: '/portfolio/new'
      path: '/portfolio/new'
      fullPath: '/portfolio/new'
      preLoaderRoute: typeof PortfolioNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/$id': {
      id: '/portfolio/$id'
      path: '/portfolio/$id'
      fullPath: '/portfolio/$id'
      preLoaderRoute: typeof PortfolioIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memory/$visitorId': {
      id: '/memory/$visitorId'
      path: '/memory/$visitorId'
      fullPath: '/memory/$visitorId'
      preLoaderRoute: typeof MemoryVisitorIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalysisRoute: AnalysisRoute,
  CacheRoute: CacheRoute,
  ChatRoute: ChatRoute,
  ContentRoute: ContentRoute,
  EventsRoute: EventsRoute,
  FediverseRoute: FediverseRoute,
  MessagesRoute: MessagesRoute,
  ResumeRoute: ResumeRoute,
  SearchRoute: SearchRoute,
  SeoRoute: SeoRoute,
  SettingsRoute: SettingsRoute,
  TrafficRoute: TrafficRoute,
  TrashRoute: TrashRoute,
  MemoryVisitorIdRoute: MemoryVisitorIdRoute,
  PortfolioIdRoute: PortfolioIdRoute,
  PortfolioNewRoute: PortfolioNewRoute,
  PostsSlugRoute: PostsSlugRoute,
  PostsNewRoute: PostsNewRoute,
  MemoryIndexRoute: MemoryIndexRoute,
  PortfolioIndexRoute: PortfolioIndexRoute,
  PostsIndexRoute: PostsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
